
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm vivek-bansod section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> अक्षय तृतीया कीर्तन मंगल वाद्य के साथ शुभ मुहूर्त, <br>शुभ कीर्तन, शुभ कार्यो अतः शुभ विचारों की
                शुभ<br><span > शुरवात के लिए</span></h2>
        </div>
        <div class="row mt-5">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">DR. VIVEK BANSOD (DIRECTOR) <span class="small-sm"> 26 APRIL 2020</span></h2>
                    <p>Mahakal Institute of Technology Ujjain, Professor Mechanical Engineering., B high Grade from
                        Akashwani in Harmonium, Harikirtankar Hindi & Marathi, Harmonium, pipe harmonium, 22 shruti
                        Harmonium player, research in music and mathematics.</p>
                </div>

                <h6 class="fw-bold">LET’S MEET THEN.</h6>
                <h6 class="fw-bold">G.H. RAISONI SPORTS & CULTURAL FOUNDATION ORGANIZES - ONLINE SESSION</h6>
                <p>Speaker : Dr. Vivek Bansod</p>
                <p>Topic : अक्षय तृतीया कीर्तन मंगल वाद्य के साथ शुभ मुहूर्त, शुभ कीर्तन, शुभ कार्यो अतः शुभ विचारों की
                    शुभ शुरवात के लिए</p>
                <p>Date : Sunday 26<sup>th</sup>April 2020</p>
                <p>Time : 6:00 PM</p>
                <p>Venue : Your Home at your Mobile</p>

                <h6 class="fw-bold">NOTE - LOGIN TO YOUR FACEBOOK ACCOUNTS 10 MINS BEFORE THE SESSION</h6>
                <p>Link: <a href="https://facebook.com/sgrkf/live" target="_blank">https://facebook.com/sgrkf/live</a>
                </p>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/VivekBansod-Invitation.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">MEDIA COVERAGE</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="media#media_classical" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">VIDEOS</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <iframe width="100%" height="230"
                    src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fsgrkf%2Fvideos%2F934135250390730%2F&show_text=false&width=560&t=0"
                    allowfullscreen></iframe>

            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">PHOTOS</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
